var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bg-dark-blue dark-bar pb-2 pb-md-0" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        {
          staticClass:
            "padding-20 d-flex justify-content-between align-items-center",
        },
        [
          _c("div", { staticClass: "icon e-rovinieta-icon" }),
          _c(
            "div",
            { staticClass: "d-flex about-vignette align-items-center" },
            [
              _c("div", { staticClass: "icon danger-sign-icon" }),
              _vm.isDesktop()
                ? _c(
                    "span",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.openModal("infoModal")
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("about") +
                              " " +
                              _vm.capitalize(_vm.$t("site_erv"))
                          ) +
                          " "
                      ),
                    ]
                  )
                : _c(
                    "span",
                    {
                      staticClass: "fs-12",
                      on: {
                        click: function ($event) {
                          return _vm.openModal("infoModal")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("info")))]
                  ),
            ]
          ),
        ]
      ),
    ]),
    _c(
      "div",
      { staticClass: "modal", attrs: { id: "infoModal", tabindex: "-1" } },
      [
        _c("div", { staticClass: "modal-dialog modal-lg" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("div", { staticClass: "modal-title heading-small" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("about") + " " + _vm.capitalize(_vm.$t("site_erv"))
                    ) +
                    " "
                ),
              ]),
              _vm._m(0),
            ]),
            _c("div", { staticClass: "modal-body px-0 pt-0" }, [
              _c(
                "div",
                { staticClass: "default-content" },
                [_c("AboutErovContent")],
                1
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("div", { staticClass: "icon icon-x" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }